import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { calendarApi } from '../api/calendarApi';
import { filterParamsKey, type CalendarQueryParams } from '../api/calendarFilterParams';
import { keepWhenOnlyFiltersChange } from './keepWhenOnlyFiltersChange';

export function useCalendarMonth(
  locationId: number | null | undefined,
  year: number,
  month: number,
  options?: { enabled?: boolean; filters?: CalendarQueryParams },
) {
  const filters = options?.filters ?? {};
  const queryKey = keys.calendar.month(locationId ?? 0, year, month, filterParamsKey(filters));
  return useQuery({
    queryKey,
    queryFn: ({ signal }: QueryFunctionContext) => calendarApi.getMonth(locationId!, year, month, filters, { signal }),
    enabled: (options?.enabled ?? true) && locationId != null,
    staleTime: 180_000,
    refetchOnMount: 'always',
    placeholderData: keepWhenOnlyFiltersChange<Awaited<ReturnType<typeof calendarApi.getMonth>>>(queryKey),
  });
}
